var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_595_24377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_595_24377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 44C11.2333 44 8.875 43.025 6.925 41.075C4.975 39.125 4 36.7667 4 34C4 31.2333 4.975 28.875 6.925 26.925C8.875 24.975 11.2333 24 14 24C16.7667 24 19.125 24.975 21.075 26.925C23.025 28.875 24 31.2333 24 34C24 36.7667 23.025 39.125 21.075 41.075C19.125 43.025 16.7667 44 14 44ZM41.2 42L28.4 29.2C28 28.7667 27.575 28.325 27.125 27.875C26.675 27.425 26.2333 27 25.8 26.6C27.0667 25.8 28.0833 24.7333 28.85 23.4C29.6167 22.0667 30 20.6 30 19C30 16.5 29.125 14.375 27.375 12.625C25.625 10.875 23.5 10 21 10C18.5 10 16.375 10.875 14.625 12.625C12.875 14.375 12 16.5 12 19C12 19.2 12.0083 19.3917 12.025 19.575C12.0417 19.7583 12.0667 19.95 12.1 20.15C11.5 20.2167 10.8417 20.35 10.125 20.55C9.40833 20.75 8.76667 20.9833 8.2 21.25C8.13333 20.8833 8.08333 20.5167 8.05 20.15C8.01667 19.7833 8 19.4 8 19C8 15.3667 9.25833 12.2917 11.775 9.775C14.2917 7.25833 17.3667 6 21 6C24.6333 6 27.7083 7.25833 30.225 9.775C32.7417 12.2917 34 15.3667 34 19C34 20.4333 33.775 21.7917 33.325 23.075C32.875 24.3583 32.25 25.5333 31.45 26.6L44 39.2L41.2 42ZM10.45 38.95L14 35.4L17.5 38.95L18.95 37.55L15.4 34L18.95 30.45L17.55 29.05L14 32.6L10.45 29.05L9.05 30.45L12.6 34L9.05 37.55L10.45 38.95Z",
    fill: "#40DF9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchOff);
export default __webpack_public_path__ + "static/media/icon-search-off.558f61a007c22331a26914fbd361ad6d.svg";
export { ForwardRef as ReactComponent };